import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetAllIntegrationsStatusResponseData } from "schema"
import z from "zod"

type AuthResponse = DataResponse<z.infer<typeof GetAllIntegrationsStatusResponseData>>

type Options = {
  onSuccess?: (data: z.infer<typeof GetAllIntegrationsStatusResponseData>) => void
}

export const integrationsStatusQuery = ({ onSuccess }: Options = {}) => {
  return queryOptions({
    queryKey: ["integrations"],
    queryFn: async () => {
      const { data } = await axios.get<AuthResponse>(`/integrations`)
      onSuccess?.(data.data)
      return data.data
    },
  })
}
